'use client'

import { useRouter, useSearchParams, usePathname } from 'next/navigation'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { Breadcrumb } from '@/General/Breadcrumb'

const brands = [
  { label: 'Vanishing Inc.', href: '/playing-cards/brand/vanishinginc/' },
  { label: 'Theory 11', href: '/playing-cards/brand/theory11/' },
  { label: 'Gemini Playing Cards', href: '/playing-cards/brand/gemini/' },
  { label: 'TCC', href: '/playing-cards/brand/TCCPresents/' },
  { label: 'Blue Crown', href: '/playing-cards/brand/TheBlueCrown/' },
  {
    label: 'Conjuring Arts',
    href: '/playing-cards/brand/ConjuringArtsResearchCenter/',
  },
  { label: 'Riffle Shuffle', href: '/playing-cards/brand/RiffleShuffle/' },
]

const PlayingCardsHeader = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const pathname = usePathname()

  /* Handle the /playing-cards/brand/xxx/ pages */
  const brand = pathname.split('/').includes('brand')
    ? pathname.split('/').pop()?.replace('/', '')
    : null

  const currentBrand = brands.find(b =>
    b.href.toLowerCase().includes((brand || '').toLowerCase())
  )

  const breadcrumbPages = [
    { name: 'Playing Cards', href: '/playing-cards' },
    ...(brand ? [{ name: currentBrand?.label || '', href: '#' }] : []),
  ]

  const handleSortChange = (value: string) => {
    const params = new URLSearchParams(searchParams.toString())
    params.set('sort', value)
    router.push(`?${params.toString()}`)
  }

  return (
    <>
      {brand && <Breadcrumb pages={breadcrumbPages} />}

      <div
        className="hidden md:flex p-2 rounded mb-2"
        style={{ background: '#f2f2f2' }}
      >
        <Menu as="div" className="relative inline-block text-left mr-auto">
          <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50">
            {brand ? `Other popular deck brands` : 'Filter by deck brands'}
            <ChevronDownIcon
              aria-hidden="true"
              className="-mr-1 h-5 w-5 text-gray-400"
            />
          </MenuButton>
          <MenuItems className="absolute left-0 z-10 w-56 origin-top-left rounded-md bg-white ring-1 shadow-lg ring-black/5 focus:outline-none">
            <div className="py-1">
              {(brand
                ? brands.filter(b => !b.href.includes(brand))
                : brands
              ).map(brand => (
                <MenuItem
                  key={brand.label}
                  as="a"
                  href={brand.href}
                  className={({ active }) =>
                    `block px-4 py-2 text-sm ${
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                    }`
                  }
                >
                  {brand.label}
                </MenuItem>
              ))}
            </div>
          </MenuItems>
        </Menu>

        {/* Sort by dropdown */}
        <div className="flex items-center">
          <span>Sort by:</span>
          <select
            value={searchParams.get('sort') || 'dateAdded.DESC'}
            onChange={e => handleSortChange(e.target.value)}
            className="ml-2 inline-block w-auto px-4 py-2 border border-gray-300 rounded-md bg-white text-gray-700 text-sm"
          >
            <option value="dateAdded.DESC">Newest First</option>
            <option value="dateAdded.ASC">Oldest First</option>
            <option value="name.ASC">Name (A-Z)</option>
            <option value="name.DESC">Name (Z-A)</option>
            <option value="displayPrice.ASC">Price (Low to High)</option>
            <option value="displayPrice.DESC">Price (High to Low)</option>
          </select>
        </div>
      </div>
    </>
  )
}

export default PlayingCardsHeader
